module.exports = __webpack_public_path__ + "2243350792cba95ad89ad5120bd1c483.png";